'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { UNPUBLISHED_CONTENT } from '../actions/ActionTypes';
import { receiveContent, requestContent, requestedContentFailed, requestedUnpublishContentFailure, requestedUnpublishContentSuccess, requestUnpublishContent } from '../actions/ContentActions';
import { closeModal } from '../actions/ModalActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(UNPUBLISHED_CONTENT).pipe(mergeMap(({
  payload: {
    contentPageId,
    contentType
  }
}) => ContentClient.unpublishContent(contentType, contentPageId).pipe(mergeMap(() => ContentClient.fetchContent({
  contentPageId,
  contentType
}).pipe(mergeMap(content => of(receiveContent(content), closeModal(), requestedUnpublishContentSuccess(contentType))), catchError(error => of(requestedContentFailed(error))), startWith(requestContent()))), catchError(error => of(requestedUnpublishContentFailure(error, contentType))), startWith(requestUnpublishContent())))));